import { PostList } from './PostList';
import { ThreadPost } from './ThreadPost';
import { ThreadFirstPost } from './ThreadFirstPost';
import { TaskContent } from './TaskContent';
import { Post } from './Post';

export abstract class PostFactory {
  public static getInstance(id: string, init: any): Post {
    //console.log(init);
    const time = this.getTimestamp(init)

    const contents = init.contents!;

    if (!contents) {
      const dummy = new ThreadPost(id, '', '', new Date());
      return new ThreadFirstPost('', dummy);
    }

    const threadPost = new ThreadPost(id, init.contents!, init.username!, time);

    if (init.hasOwnProperty('number')) {
      const threadFirstPost = new ThreadFirstPost(init.title!, threadPost);
      const taskContent = new TaskContent(init.number!, threadFirstPost);
      return taskContent;
    }

    if (init.hasOwnProperty('title')) {
      const threadFirstPost = new ThreadFirstPost(init.title!, threadPost);
      return threadFirstPost;
    }

    return threadPost
  }

  private static getTimestamp(data: any): Date {
    if (data.timestamp && data.timestamp.seconds) {
      return new Date(data.timestamp.seconds * 1000);
    }
    if (data.timestamp) {
      return new Date(data.timestamp);
    }
  
    return new Date();
  }
}